import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f29c7a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tir-pm-video-player-slider_pointer_time"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-video-player-slider_pointer_time_triangle" }, null, -1))

import { computed, onMounted, onUnmounted, ref } from 'vue'

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-video-player-slider',
  props: {
  /**Курсор наведен на видеоплеер */
  isOver: { type: Boolean, default: false },
  /**Текущее время просмотра */
  currentTime: { type: Number, default: 0 },
  /**Время видео */
  duration: { type: Number, default: 0 },
  /**Проигрывается ли видео */
  play: { type: Boolean, default: false },
},
  emits: ["mouseDown", "mouseUp", "switch"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Зажата ли ЛКМ */
const isMouseDown = ref(false)
/**Была ли зажата ЛКМ хотя бы раз */
const isMouseDownOnce = ref(false)
/**DOM элемент полосы прокрутки */
const $slider = ref<HTMLElement>()
/**Ширина полосы */
const elWidth = ref()
/**Текущее время проигрывания */
const newCurrent = ref<number>()

/**Процент прошедшего времени */
const currentTimePercent = computed(() => {
  const currentTime = props.currentTime || 0
  const duration = props.duration || 0
  return (currentTime / duration || 0) * 100 + '%'
})
/**Стиль полоски с текущим временем */
const currentTimeStyle = computed(() => ({
  width: currentTimePercent.value,
}))
/**Стиль поинтера */
const pointerStyle = computed(() => ({
  left: `calc(${currentTimePercent.value} - 0.5rem)`,
}))
/**Получить время в формате 01:01:01 */
const currentTimeText = computed(() => {
  const hours = upScaleLength(Math.floor(props.currentTime / 3600))
  const minutes = upScaleLength(Math.floor(props.currentTime % 3600) / 60)
  const seconds = upScaleLength(Math.floor(props.currentTime % 3600) % 60)
  return `${hours}:${minutes}:${seconds}`
})

/**Добавление "0" для таймера */
const upScaleLength = (_seconds: number) => {
  const seconds = _seconds.toFixed(0).toString()
  return seconds.length < 2 ? '0' + seconds : seconds
}

/**После рендера компоенента */
onMounted(() => {
  window.addEventListener('resize', windowOnResize)
  windowOnResize()
})
/**При удалении компонента */
onUnmounted(() => {
  window.removeEventListener('resize', windowOnResize)
})

/**При изменении размера окна браузера */
function windowOnResize() {
  if (!$slider.value) return
  elWidth.value = $slider.value.getBoundingClientRect().width
}
/**При зажатии ЛКМ на полосе */
const onMouseDown = (e: MouseEvent) => {
  if (!isMouseDownOnce.value) emit('mouseDown')
  isMouseDownOnce.value = true
  isMouseDown.value = true
  if (!$slider.value) return
  windowOnResize()
  let sliderRect = $slider.value.getBoundingClientRect()
  let clickAt = ((e.pageX - sliderRect.left) / elWidth.value) * 100
  let secAtPercent = props.duration / 100
  newCurrent.value = clickAt * secAtPercent
  if (newCurrent.value >= props.duration) newCurrent.value = props.duration
  if (newCurrent.value <= 0) newCurrent.value = 0
  emit('switch', newCurrent.value)
  document.addEventListener('mouseup', documentOnMouseUp)
  document.addEventListener('mousemove', documentOnMouseMove)
}
/**При прекращении зажатия ЛКМ */
function documentOnMouseUp() {
  emit('mouseUp')
  document.removeEventListener('mousemove', documentOnMouseMove)
  document.removeEventListener('mouseup', documentOnMouseUp)
  isMouseDown.value = false
  isMouseDownOnce.value = false
}
/**При перемещении курсора по странице */
function documentOnMouseMove(e: MouseEvent) {
  if (isMouseDown.value) onMouseDown(e)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tir-pm-video-player-slider",
    ref_key: "$slider",
    ref: $slider,
    onMousedown: onMouseDown,
    onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args)))
  }, [
    _createElementVNode("div", {
      class: "tir-pm-video-player-slider_current",
      style: _normalizeStyle(currentTimeStyle.value)
    }, null, 4),
    _createVNode(_Transition, { name: "tir-pm-video-player-slider_animation" }, {
      default: _withCtx(() => [
        (__props.isOver)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tir-pm-video-player-slider_pointer",
              style: _normalizeStyle(pointerStyle.value)
            }, [
              (isMouseDown.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createTextVNode(_toDisplayString(currentTimeText.value) + " ", 1),
                    _hoisted_2
                  ]))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 544))
}
}

})